import { formatTimestamp } from "../utils/common";
import { getWithAuth, postJsonWithAuth, cachedPostJsonWithAuth, cachedGetWithAuth } from "./fetch";

export async function fetchStockScores(timestamp, market, pageNum, policy, searchKey, turnOnly, buyOnly, sellOnly) {
    if (timestamp === undefined || timestamp === "") {
        return [];
    }
    const formattedDate = formatTimestamp(timestamp);
    if (formattedDate.indexOf("NaN") > -1) {
        return [];
    }
    let marketParam = `&market1=${market}&market2=null`;
    if (market === "CN") {
        marketParam = "&market1=SH&market2=SZ";
    }

    let orderBy = "";
    if (policy === "fourier") {
        orderBy = "&orderBy=result1";
    } else if (policy === "fourier_new") {
        orderBy = "&orderBy=result2";
    }

    // 生成19701月1日0时到目前小时数
    const hours = Math.floor((Date.now()/1000) / 3600);
    const result = await getWithAuth(
        `/api/stockscore?startDate=${formattedDate}&endDate=${formattedDate}${marketParam}&pageNum=${pageNum}${orderBy}&searchKey=${searchKey}&turnFlag=${turnOnly}&buyFlag=${buyOnly}&sellFlag=${sellOnly}&random=${hours}&policy=${policy}`
    );
    return result;
}

export async function fetchStockScoreByCodesAndDate(timestamp, codes) {
    if (timestamp === undefined || timestamp === "") {
        return [];
    }
    const formattedDate = formatTimestamp(timestamp);
    if (formattedDate.indexOf("NaN") > -1) {
        return [];
    }
    let body = {
        startDate: formattedDate,
        endDate: formattedDate,
        codes: codes
    }

    const result = await cachedPostJsonWithAuth(
        `/api/batch/stockscore`, body
    );
    return result;
}

export async function fetchStockScoreDetail(code) {
    // 生成19701月1日0时到目前小时数
    const hours = Math.floor((Date.now()/1000) / 3600);
    const result = await cachedGetWithAuth(`/api/stockscore/${code}?limit=250&random=${hours}`);
    return result;
}

// 自定义回测区间：按日期范围取单只股票的评分数据。
// 这里故意不使用 cachedPostJsonWithAuth，自定义区间的数据不进入浏览器缓存。
export async function fetchStockScoreRangeByCode(code, startDate, endDate) {
    const result = await postJsonWithAuth(`/api/batch/stockscore`, {
        startDate,
        endDate,
        codes: [code],
    });
    return result;
}

// 前复权日 K 线（CN: Mairui，US: Polygon，HK: Futu OpenD）
export async function fetchStockKLine(market, code, startDate, endDate) {
    return getWithAuth(
        `/api/kline/${market}/${code}?startDate=${startDate}&endDate=${endDate}`
    );
}

export async function fetchRealtimeScore(market, code) {
    const result = await getWithAuth(`/api/realtime/stockscore/${market}/${code}`);
    return result;
}

export async function fetchStockAnalyze(market, code) {
    // 生成19701月1日0时到目前小时数
    const hours = Math.floor((Date.now()/1000) / 3600);
    const result = await getWithAuth(`/api/stock_analyze/${market}/${code}?random=${hours}`);
    return result;
}

export const SCORE_POLICIES = {
    US: [{ value: "default", label: "量价" },
        { value: "fourier", label: "量价+傅里叶" },
        { value: "fourier_new", label: "傅里叶回归" },
    ],
    CN: [
        { value: "default", label: "量价" },
        { value: "fourier", label: "量价+傅里叶" },
        { value: "fourier_new", label: "傅里叶回归" },
    ],
    HK: [
        { value: "default", label: "量价" },
        { value: "fourier", label: "量价+傅里叶" },
        { value: "fourier_new", label: "傅里叶回归" },
    ],
};
